import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'

import { useMediaQuery } from 'src/lib/use-media-query'
import common from 'src/styles/common.module.scss'
import styles from '../styles.module.scss'

export const TextHeaderDe = () => {
    const isDesktop = useMediaQuery('(min-width: 1024px)')

    return (
        <HighlightedText
            text="HOLEN SIE SICH IHREN BONUS"
            highlights={[
                { word: 'HOLEN' },
                { word: 'SIE' },
                { word: 'SICH' },
                { word: 'IHREN' },
                { word: 'BONUS' },
            ]}
            breakAfterWords={isDesktop ? [] : ['SICH']}
            className={common.text_header}
        />
    )
}

export const TextLandDe = () => {
    return (
        <HighlightedText
            text="325% Einzahlungsbonus + 400 FREISPIELE"
            highlights={[{ word: '325%' }, { word: '+ 400' }]}
            breakAfterWords={['Einzahlungsbonus']}
            className={styles.text_content}
        />
    )
}
